import axios from 'axios';
import { config } from '../config/env';

export const apiClient = axios.create({
  baseURL: config.backendUrl,
});

export const apiClientWithToken = (token: string) =>
  axios.create({
    baseURL: config.backendUrl,
    headers: { Authorization: `Bearer ${token}` },
  });
